(function () {
  var LABEL = 'Buy now';
  var WAIT = 'One moment...';
  /* Horizon renders TWO cart forms per product card: a quick-add form layered
     over the gallery image, and the real buy-buttons form under the price.
     Only the second one should get a Buy now button. */
  var SKIP = 'quick-add-component, .quick-add, .card-gallery, .quick-add__product-form-component';
  var scheduled = false;

  function isSkipped(form) {
    return !!(form.closest && form.closest(SKIP));
  }

  function attach(form) {
    if (!form.querySelector('[name="id"]')) return;

    if (isSkipped(form)) {
      var stray = form.querySelectorAll('.ak-buynow');
      for (var s = 0; s < stray.length; s++) stray[s].parentNode.removeChild(stray[s]);
      form.setAttribute('data-ak-buynow', 'skip');
      return;
    }

    if (form.getAttribute('data-ak-buynow') === '1') return;
    form.setAttribute('data-ak-buynow', '1');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ak-buynow';
    btn.textContent = LABEL;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var idField = form.querySelector('[name="id"]');
      if (!idField || !idField.value) return;
      var qtyField = form.querySelector('[name="quantity"]');
      var qty = parseInt((qtyField && qtyField.value) || '1', 10);
      if (!qty || qty < 1) qty = 1;
      btn.disabled = true;
      btn.textContent = WAIT;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: idField.value, quantity: qty }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function () { btn.disabled = false; btn.textContent = LABEL; });
    });

    form.appendChild(btn);
  }

  function scan() {
    scheduled = false;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) attach(forms[i]);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(scan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
